import { pWarn } from '_/helpers/logger';

import { eventBus } from '_/helpers/eventBus';

export default {
    /**
     * Define props
     *
     * @type  {Object}
     */
    props: {
        defaultValue: {
            type: [Boolean, String],
        },
        disabled: {
            type: Boolean,
        },
        id: {
            required: true,
            type: [Number, String],
        },
        name: {
            required: true,
            type: String,
        },
        refreshFields: {
            type: Number,
        },
        value: {
            default: '#ffffff',
            type: String,
        },
        focus: {
            default: false,
            type: Boolean,
        },
    },

    /**
     * Set the methods
     *
     * @type  {Object}
     */
    methods: {
        /**
         * Initializes the color picker
         *
         * @return  {void}
         */
        initializeColorPicker() {
            const $input = $(this.$el).find('input');

            const $colorPicker = $(this.$el).find('.colorpicker-binder');

            $colorPicker.farbtastic($input);

            $colorPicker.on('click', () => {
                this.setInputValueIfMissing();

                this.onChange({
                    target: {
                        id: $input.attr('id'),
                        name: $input.attr('name'),
                        value: $input.val(),
                    },
                });
            });
        },

        /**
         * Updates the color picker
         *
         * @return  {void}
         */
        updateColorPicker() {
            const $colorPicker = $(this.$el).find('.colorpicker-binder');

            $.farbtastic($colorPicker).setColor(this.value);
        },

        /**
         * Sets the input value if missing
         *
         * @return {void}
         */
        setInputValueIfMissing() {
            const $input = $(this.$el).find('input');

            const $colorPicker = $(this.$el).find('.colorpicker-binder');

            $input.val($.farbtastic($colorPicker).color);
        },

        /**
         * Creates the event payload
         *
         * @param   {object}  event
         * @return  {object}
         */
        createEventPayload(event) {
            return {
                event,
                id: event.target.id,
                name: event.target.name,
                value: event.target.value,
            };
        },

        /**
         * Emmits a change event with a payload consting of input value and the event object
         *
         * @param   {event}  event
         * @return  {void}
         */
        onChange: function (event) {
            this.$emit('change', this.createEventPayload(event));

            eventBus.$emit('fieldTypeChange', this.createEventPayload(event));
        },

        /**
         * Emmits a global change event with a payload consting of input value and the event object
         *
         * @param   {event}  event
         * @return  {void}
         */
        onBlur: function (event) {
            eventBus.$emit('fieldTypeBlur', this.createEventPayload(event));
        },

        /**
         * Sets a component value to defaultValue, if required
         *
         * @return  {void}
         */
        setDefaultValue() {
            const defaultValue = this.value === '#ffffff' && this.defaultValue ? this.defaultValue : this.value;

            this.$emit('change', {
                id: this.id,
                name: this.name,
                value: defaultValue,
            });
        },
    },

    /**
     * Set the created hook
     *
     * @return  {void}
     */
    created: function () {
        this.setDefaultValue();

        this.$nextTick(() => {
            this.initializeColorPicker();
        });
    },

    /**
     * Set the mounted hook
     *
     * @return  {void}
     */
    mounted() {
        this.$nextTick(() => {
            if (this.focus) {
                $(this.$el).find(`#${this.id}`).focus();
            }
        });
    },

    /**
     * Define watched properties
     *
     * @type  {Object}
     */
    watch: {
        refreshFields(newEntry, oldEntry) {
            if (newEntry !== oldEntry) {
                pWarn('Watched property fired.', `ColorPicker.${this.name}`, 'refreshFields', newEntry, oldEntry, this);

                this.setDefaultValue();

                this.$forceUpdate();

                $(this.$el).find('input').val(this.value);

                this.updateColorPicker();
                if (this.focus) {
                    $(this.$el).find(`#${this.id}`).focus();
                }
            }
        },
    },
};
